export default "__VITE_ASSET__BbnAjZu4__"